export class LoanActionApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getLoanActionSchema(includeCollections = false) {
    const config = includeCollections ? { params: { includeCollections: true } } : {};

    return this.#http.get('/LoanAction/fields-schema/v2', config);
  }

  async getLoanActionsHistory({ applicationId }) {
    return this.#http.get(`/LoanAction/${applicationId}/history`);
  }
}
